import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';

const Root = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: absolute;
  right: -1px;
  top: -3px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  padding: 1px;
  box-sizing: border-box;
  background-color: ${colors.white};
`;

const PinkCircle = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border-radius: 50%;
  background-color: ${colors.crunchBerry};
`;

type Props = {
  className?: string;
};

const Badge = ({ className }: Props) => (
  <Root className={className}>
    <PinkCircle />
  </Root>
);

export default Badge;
